<template>
  <div class="row">
    <div class="col-12">
      <div class="card m-b-30">
        <div class="card-header">
          <h5 class="card-title mb-0">Filtri</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <input
                type="text"
                v-model="query"
                class="form-control mb-2"
                placeholder="Codice messaggio"
              />
            </div>
          </div>

          <div class="row">
            <div class="col text-right">
              <button class="btn btn-primary-rgba mr-2" v-on:click="loaddata">
                <i class="feather icon-filter mr-2"></i>Filtra
              </button>
              <button class="btn btn-danger-rgba" v-on:click="resetdata">
                <i class="feather icon-delete mr-2"></i>Elimina filtro
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card m-b-30">
        <div class="card-body">
          <router-link
            v-if="$store.getters.isInRole('template-edit')"
            class="btn btn-sm btn-primary"
            :to="{
              name: 'route-messagetemplate-edit',
              params: { id: '00000000-0000-0000-0000-000000000000' },
            }"
          >
            <font-awesome-icon icon="plus-circle"></font-awesome-icon>Aggiungi
            nuovo template
          </router-link>

          <table
            ref="table"
            id="list-messagetemplate-table"
            class="table w-100"
          ></table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {},
  components: {},
  data() {
    return {
      query: "",
    };
  },
  name: "messageTemplateList",
  beforeMount() {
    var me = this;
  },

  mounted() {
    var me = this;
    if (localStorage.getItem("messagetemplate-list-query"))
      me.query = localStorage.getItem("messagetemplate-list-query");

    setTimeout(this.loaddata, 200);
  },
  methods: {
    edit: function (id) {
      this.$router.push({
        name: "route-messagetemplate-edit",
        params: { id: id },
      });
      return false;
    },
    resetdata() {
      this.query = "";

      this.loaddata();
    },
    loaddata: function () {
      window["EditAction"] = this.edit;
      var me = this;

      var edit = "M";
      if (me.$refs && me.$refs.edit && me.$refs.edit.outerHTML) {
        edit = me.$refs.edit.outerHTML;
      }

      var remove = "C";
      if (me.$refs && me.$refs.remove && me.$refs.remove.outerHTML) {
        remove = me.$refs.remove.outerHTML;
      }
      if ($.fn.DataTable.isDataTable("#list-messagetemplate-table")) {
        $("#list-messagetemplate-table").DataTable().destroy();
      }

      var $table = $("#list-messagetemplate-table").DataTable({
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url: window.SETTINGS.apiUrl + "/messageTemplate/list",
          type: "POST",
          data: function (d) {
            localStorage.setItem("messagetemplate-list-query", me.query);

            d.search.value = me.query;

            d.filters = [];

            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },

        columns: [
          {
            data: "messageTemplateId",
            name: "messageTemplateId",
            title: "Codice",
            render: function (data, type, row, meta) {
              return row.messageCode;
            },
          },
          {
            className: "text-right",
            data: "messageTemplateId",
            name: "messageTemplateId",
            title: "Azioni",
            render: function (data, type, row, meta) {
              if (me.$store.getters.isInRole("template-edit")) {
               if(!row.systemTemplate)
                return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.EditAction('${data}')"><i class="feather icon-edit-2"></i></button>
                                    <button type="button" class="btn btn-danger-rgba remove-action"  data-id="${data}"><i class="feather icon-trash"></button></div>`;
                                    else 
                                                    return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.EditAction('${data}')"><i class="feather icon-edit-2"></i></button>`;
              } else {
                return `<div class="button-list"><button type="button" class="btn btn-information-rgba" data-id="${data}" onClick="window.EditAction('${data}')"><i class="feather icon-info"></i></button>`;
              }
            },
          },
        ],
      });

    
    },
  },
};
</script>
